const React = require('react');
const T = require('prop-types');
const SearchResult = require('containers/SearchResult');
const { default: Styled } = require('styled-components');
const { default: ImageList } = require('@mui/material/ImageList');
const { useMediaQuery } = require('@mui/material');

const { useEffect, useRef } = React;

const { default: Classes } = require('./styles.scss');
const { default: styled } = require('styled-components');

const internals = {};

const SearchResultGrid = (props) => {

    const {
        results,
        weeklyLeaderRanks,
        showConnectionStatus,
        showDistance,
        scrollToIndex,
        onScrollComplete,
        focusIndex,
        isFromDiscover = false,
        isFromGroup = false,
        groupId,
        debug
    } = props;

    const {
        ResultWrapperGridContainer,
        StyledImageList
    } = internals;

    const mql = useMediaQuery('screen and (min-width: 600px), screen and (max-width: 415px)');
    const mqlMobile = useMediaQuery('(max-width: 600px)');
    const imageListRef = useRef(null);

    useEffect(() => {

        if (typeof scrollToIndex === 'number' && scrollToIndex >= 0 && scrollToIndex < results.length && imageListRef.current) {
            const targetElement = imageListRef.current.children[scrollToIndex];

            if (targetElement && typeof targetElement.scrollIntoView === 'function') {
                targetElement.scrollIntoView({
                    behavior: 'instant',
                    block: 'center'
                });

                if (onScrollComplete) {
                    setTimeout(onScrollComplete, 100);
                }
            }
            else if (onScrollComplete) {
                setTimeout(onScrollComplete, 100);
            }
        }
    }, [scrollToIndex, results.length, onScrollComplete]);

    useEffect(() => {

        if (typeof focusIndex === 'number' && focusIndex >= 0 && imageListRef.current) {
            const clampedIndex = Math.min(focusIndex, results.length - 1);
            const targetElement = imageListRef.current.children[clampedIndex];
            const focusable = targetElement && targetElement.querySelector('a, button');

            if (focusable) {
                focusable.focus({ preventScroll: false });
            }
        }
    }, [focusIndex]);

    return (
        <ResultWrapperGridContainer className="SearchResultGrid">
            <StyledImageList
                ref={imageListRef}
                length={results.length}
                classes={{
                    root: results.length > 1 && !mqlMobile && Classes.center
                }}
                rowHeight={200}
                cols={mqlMobile ? 1 : 2}
                className={Classes.imageList}
            >
                {results.map((result, index) => (

                    <SearchResult
                        key={result.id}
                        result={result}
                        weeklyLeaderRank={(isFromDiscover || isFromGroup) ? weeklyLeaderRanks?.[result.id] : undefined}
                        resultIndex={index}
                        numOfResults={results.length}
                        useIconButton={mql}
                        showConnectionStatus={showConnectionStatus}
                        showDistance={showDistance}
                        isFromDiscover={isFromDiscover}
                        isFromGroup={isFromGroup}
                        groupId={groupId}
                        debug={debug}
                    />
                ))}
            </StyledImageList>
        </ResultWrapperGridContainer>
    );
};

SearchResultGrid.propTypes = {
    weeklyLeaderRanks: T.object,
    results: T.array,
    showConnectionStatus: T.bool,
    showDistance: T.bool,
    scrollToIndex: T.number,
    onScrollComplete: T.func,
    focusIndex: T.number,
    isFromDiscover: T.bool,
    isFromGroup: T.bool,
    groupId: T.number,
    debug: T.bool
};

module.exports = SearchResultGrid;

internals.ResultWrapperGridContainer = Styled.div`
    overflow: hidden;
    padding: 0.5em 2em;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 960px) {
        justify-content: center;
    }

    @media screen and (max-width: 600px) {
        padding: 8px 22px;

        li {
            margin: 0 12px;
            margin-bottom: 12px;
        }
    }
`;

internals.StyledImageList = styled(ImageList)(({ theme }) => ({
    overflow: 'hidden',
    [theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.md)]: {
        justifyContent: 'center',
        width: '100%'
    }
}));
